import React, { useState } from 'react';
import { motion } from 'framer-motion';
import CardSoft from '../ui/CardSoft';
import SectionTitle from '../common/SectionTitle';
import {
    FaFemale,
    FaTint,
    FaNotesMedical,
    FaSpa,
    FaGem,
    FaHeart,
    FaRunning,
    FaCheck,
    FaBacteria,
    FaPalette,
    FaUserMd,
    FaCut,
    FaStethoscope,
    FaMicroscope,
    FaBolt,
    FaFlask,
    FaSyringe,
    FaMagic,
    FaVenusMars,
    FaVenus
} from 'react-icons/fa';

const ServicesGrid = () => {
    const [hoveredCard, setHoveredCard] = useState(null);

    // Handle scroll to specific service card based on hash
    React.useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            setTimeout(() => {
                const element = document.getElementById(hash.substring(1));
                if (element) {
                    // Calculate offset to account for navbar height
                    const navbarHeight = 100; // Adjust based on your navbar height
                    const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
                    const offsetPosition = elementPosition - navbarHeight - 20; // 20px extra padding

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            }, 300);
        }
    }, []);

    const categories = [
        // C. VULVOVAGINAL & INTIMATE HEALTH (1st)
        {
            id: 'vulvovaginal-conditions',
            title: 'Vulvovaginal Conditions',
            icon: <FaFemale size={30} color="var(--primary)" />,
            items: [
                'Vaginal laxity',
                'Vaginal dryness',
                'Vaginismus',
                'Post childbirth laxity',
                'Post menopausal atrophy',
                'Cervical rejuvenation',
                'Lichen sclerosus'
            ]
        },
        // E. FEMININE & SEXUAL WELLNESS (2nd)
        {
            id: 'feminine-sexual-wellness',
            title: 'Feminine & Sexual Wellness',
            icon: <FaVenusMars size={30} color="var(--primary)" />,
            items: [
                'Vulval rejuvenation',
                'Vaginal rejuvenation',
                'O-shot',
                'G-shot',
                'Kamasutra shot'
            ]
        },
        // F. COSMETIC & BODY AESTHETICS (3rd) - Updated "Momma" to "Mommy"
        {
            id: 'mumma-makeover',
            title: 'Mumma Makeover',
            icon: <FaVenus size={30} color="var(--primary)" />,
            items: [
                'Mumma makeover',
                'Vulval fillers',
                'Labial fillers',
                'Labial tightening',
                'Intimate bleaching',
                'Sclerotherapy'
            ]
        },
        // D. PELVIC FLOOR REHABILITATION (4th)
        {
            id: 'pelvic-floor-rehabilitation',
            title: 'Pelvic Floor Rehabilitation',
            icon: <FaRunning size={30} color="var(--primary)" />,
            items: [
                'Bladder hypersensitivity',
                'Voiding dysfunction',
                'Recurrent UTI',
                'Pelvic pain',
                'Vaginal laxity',
                'Pelvic organ prolapse',
                'Anal incontinence'
            ]
        },
        // URINARY CONDITIONS (5th)
        {
            id: 'urinary-conditions',
            title: 'Urinary Conditions',
            icon: <FaTint size={30} color="var(--primary)" />,
            items: [
                'Urge incontinence',
                'Stress incontinence'
            ]
        },
        // CERVICAL CONDITIONS (6th)
        {
            id: 'cervical-conditions',
            title: 'Cervical Conditions',
            icon: <FaNotesMedical size={30} color="var(--primary)" />,
            items: [
                'Cervical erosion',
                'Cervical ectopy',
                'HPV infections',
                'Cervical infections',
                'Cervical rejuvenation'
            ]
        },
        // COSMETIC & BODY AESTHETICS (7th) - Removed, already included as Mommy Makeover above

        // A. MEDICAL DERMATOLOGY
        {
            id: 'skin-infections-medical',
            title: 'Skin Infections & Medical Conditions',
            icon: <FaBacteria size={30} color="var(--primary)" />,
            items: [
                'Fungal infections',
                'Psoriasis',
                'Eczema',
                'Lichen planus',
                'Bullous disorders',
                'Bacterial & viral infections',
                'Leprosy',
            ]
        },
        {
            id: 'Sexually Transmitted Diseases (STDs)',
            title: 'Sexually Transmitted Diseases (STDs)',
            icon: <FaBacteria size={30} color="var(--primary)" />,
            items: [

            ]
        },
        {
            id: 'pigmentation-skin-brightening',
            title: 'Pigmentation ',
            icon: <FaPalette size={30} color="var(--primary)" />,
            items: [
                'Melasma',
                'Vitiligo',
                'freckles',
                'photomelanosis',
                'perioral and periorbital melanosis',
            ]
        },
        {
            id: 'acne-scar-management',
            title: 'Acne & Scar Management',
            icon: <FaUserMd size={30} color="var(--primary)" />,
            items: [
                'Acne treatment',
                'Acne scar treatment',
                'Nodulocystic acne',
                'Scar revision',
                'Microneedling',
                'Microneedling with iPRF'
            ]
        },
        {
            id: 'skin-growth-lesion-removal',
            title: 'Radio frequency & electrocautery',
            icon: <FaStethoscope size={30} color="var(--primary)" />,
            items: [
                'Skin tags',
                'DPN',
                'Warts',
                'Molluscum',
                'Milia',
                'Sebaceous cyst',
                'Mole removal'
            ]
        },
        {
            id: 'advanced-dermatology',
            title: 'Skin Analysis & Skin Cancer Screening',
            icon: <FaMicroscope size={30} color="var(--primary)" />,
            items: [
                'Intralesional steroid therapy (ILS)',
                'Dermoscopy',
                'Skin biopsy'
            ]
        },
        {
            id: 'laser-energy-treatments',
            title: 'Laser & Energy-Based Treatments',
            icon: <FaBolt size={30} color="var(--primary)" />,
            items: [
                'CO2 Laser',
                'Nd:YAG Laser',
                'Fractional Laser',
                'Diode Laser',
                'IPL',
                'Tattoo removal'
            ]
        },

        // B. AESTHETIC & COSMETIC DERMATOLOGY
        {
            id: 'chemical-peels',
            title: 'Skin Peel Treatments',
            icon: <FaFlask size={30} color="var(--primary)" />,
            items: [
                'Peel for Melasma',
                'Peel for Hyperpigmentation',
                'Peel for Tanning',
                'Peel for Freckles',
                'Peel for Acne',
                'Peel for Acne Scars',
                'Peel for Uneven Skin Tone',
                'Anti-Aging Peel'
            ]
        },
        {
            id: 'injectables-aesthetics',
            title: 'Injectables & Aesthetics',
            icon: <FaSyringe size={30} color="var(--primary)" />,
            items: [
                'Botox',
                'Fillers',
                'Skin boosters',
                'Iv drip for glow',
                'ILS'
            ]
        },
        {
            id: 'skin-rejuvenation',
            title: 'Skin Rejuvenation',
            icon: <FaMagic size={30} color="var(--primary)" />,
            items: [
                'PRP with Dermapen',
                'Anti-aging therapies',
                'Exosome for skin rejuvenation'
            ]
        },
        {
            id: 'hair-restoration',
            title: 'Hair Restoration',
            icon: <FaCut size={30} color="var(--primary)" />,
            items: [
                'PRP hair therapy',
                'Hair transplant',
                'GFC (Growth Factor Concentrate)',
                'Exosome for hair growth'
            ]
        }
    ];

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.5, ease: "easeOut" }
        }
    };

    return (
        <section className="section" style={{ backgroundColor: 'transparent' }}>
            <div className="container">
                <SectionTitle title="Our Complete Range of Services" />
                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
                        gap: '30px',
                        alignItems: 'start'
                    }}
                >
                    {categories.map((category, index) => (
                        <motion.div
                            variants={itemVariants}
                            key={index}
                            id={category.id}
                            style={{
                                height: 'auto',
                                cursor: 'pointer'
                            }}
                            onMouseEnter={() => setHoveredCard(index)}
                            onMouseLeave={() => setHoveredCard(null)}
                        >
                            <CardSoft style={{
                                padding: '40px',
                                border: '1px solid rgba(181, 131, 131, 0.2)',
                                borderRadius: '24px',
                                height: 'auto',
                                backgroundColor: hoveredCard === index ? '#faf8f8' : 'var(--white)',
                                transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                                position: 'relative',
                                overflow: 'visible',
                                display: 'flex',
                                flexDirection: 'column',
                                transform: hoveredCard === index ? 'translateY(-8px)' : 'translateY(0)',
                                boxShadow: hoveredCard === index ? '0 20px 40px rgba(181, 131, 131, 0.2)' : '0 10px 30px rgba(0,0,0,0.08)'
                            }}
                            >
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginBottom: hoveredCard === index ? '25px' : '0',
                                    borderBottom: hoveredCard === index ? '1px solid rgba(181, 131, 131, 0.1)' : 'none',
                                    paddingBottom: hoveredCard === index ? '20px' : '0',
                                    transition: 'all 0.3s ease'
                                }}>
                                    <div style={{
                                        marginRight: '20px',
                                        background: 'rgba(181, 131, 131, 0.08)',
                                        width: '60px',
                                        height: '60px',
                                        borderRadius: '16px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexShrink: 0,
                                        transition: 'all 0.3s ease'
                                    }}>
                                        {category.icon}
                                    </div>
                                    <h3 style={{
                                        fontFamily: 'var(--font-heading)',
                                        fontSize: '1.5rem',
                                        color: 'var(--secondary)',
                                        margin: 0,
                                        transition: 'color 0.3s ease'
                                    }}>
                                        {category.title}
                                    </h3>
                                </div>

                                {hoveredCard === index && (
                                    <motion.div
                                        initial={{ opacity: 0, height: 0 }}
                                        animate={{ opacity: 1, height: 'auto' }}
                                        exit={{ opacity: 0, height: 0 }}
                                        transition={{ duration: 0.3 }}
                                    >
                                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                            {category.items.map((item, idx) => (
                                                <li key={idx} style={{
                                                    marginBottom: '12px',
                                                    display: 'flex',
                                                    alignItems: 'flex-start',
                                                    fontSize: '0.95rem',
                                                    color: 'var(--text-light)',
                                                    lineHeight: '1.5',
                                                    transition: 'all 0.2s ease'
                                                }}>
                                                    <span style={{
                                                        color: 'var(--primary)',
                                                        marginRight: '12px',
                                                        marginTop: '4px',
                                                        fontSize: '0.8rem'
                                                    }}>
                                                        <FaCheck />
                                                    </span>
                                                    {item}
                                                </li>
                                            ))}
                                        </ul>
                                    </motion.div>
                                )}
                            </CardSoft>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
};

export default ServicesGrid;
